<template>
    <q-dialog persistent ref="dialog" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <template v-if="headerText">
                    <div class="text-h6">{{ headerText }}</div>
                </template>
                <template v-else>
                    <div class="text-h6">Pay at store</div>
                </template>
            </q-card-section>

            <q-card-section>
                <div class="text-subtitle1">Order ID</div>
                <q-input dense readonly outlined v-model="orderID">
                    <!-- <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template> -->
                </q-input>
                <div class="text-subtitle1">Bill ID</div>
                <q-input
                    :rules="[(val) => !!val || 'Field is required']"
                    ref="billID"
                    dense
                    clearable
                    outlined
                    v-model="billID"
                >
                    <!-- <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template> -->
                </q-input>
                <div class="text-subtitle1">Total</div>
                <q-input dense readonly outlined v-model="grandTotal">
                    <!-- <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template> -->
                </q-input>
                <div class="text-subtitle1">Total paid</div>
                <q-input
                    :rules="[(val) => !!val || 'Field is required']"
                    ref="totalPaid"
                    dense
                    clearable
                    type="number"
                    outlined
                    v-model.number="totalPaid"
                >
                    <!-- <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template> -->
                </q-input>
                <div class="text-subtitle1">Remark</div>
                <q-input
                    ref="remark"
                    type="textarea"
                    dense
                    clearable
                    outlined
                    v-model="remark"
                >
                    <!-- <template v-slot:append>
                        <q-btn
                            @click="onCopy"
                            flat
                            round
                            color="primary"
                            icon="content_copy"
                        />
                    </template> -->
                </q-input>
            </q-card-section>

            <!-- <q-card-actions align="right">
                <q-btn
                    unelevated
                    no-caps
                    color="primary"
                    label="Send Email"
                    disable
                />
                <q-btn
                    unelevated
                    no-caps
                    color="primary"
                    label="Send SMS"
                    disable
                />
            </q-card-actions> -->

            <q-separator />

            <!-- buttons example -->
            <q-card-actions align="right">
                <template v-if="!hideClearCart">
                    <q-btn
                        unelevated
                        no-caps
                        color="primary"
                        label="Close and Clear cart"
                        @click="onOKClick"
                    />
                </template>
                <q-btn
                    unelevated
                    :disable="loading"
                    no-caps
                    color="primary"
                    label="OK"
                    @click="onOKClick"
                />
                <q-btn
                    unelevated
                    no-caps
                    color="white"
                    text-color="primary"
                    label="Cancel"
                    @click="onCancelClick"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import { copyToClipboard } from "quasar";
export default {
    name: "PayAtStoreDialog",
    // props: ["text", "orderID", "headerText", "hideClearCart"],
    props: {
        text: {
            type: String,
        },
        orderID: {
            type: String,
        },
        order: {
            type: Object,
        },
        headerText: {
            type: String,
        },
        hideClearCart: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        // REQUIRED
        "ok",
        "hide",
    ],
    data() {
        return {
            billID: null,
            totalPaid: null,
            remark: "",
            subTotal: null,
            grandTotal: null,
            discountAmount: null,
            shippingAmount: null,
            loading: true,
        };
    },
    computed: {
        url() {
            return `https://portal.villamarket.net/pay/${this.text}`;
        },
    },
    mounted() {
        console.log("mounted:", this.text);
        this.loadGrandTotal();
    },
    methods: {
        async loadGrandTotal() {
            const apikey = await this.$services.authentication.getApikey();
            const order = await this.$services.calculatePrice.getResolveCoupon(
                this.order,
                apikey.key
            );

            console.log({ order });
            this.grandTotal = order.grandTotal;
            this.subTotal = order.subTotal;
            this.discountAmount = order.totalDiscount;
            this.shippingAmount = order.deliveryFee;
            this.loading = false;
            // this.order = order;
        },
        // following method is REQUIRED
        // (don't change its name --> "show")
        show() {
            this.$refs.dialog.show();
        },

        // following method is REQUIRED
        // (don't change its name --> "hide")
        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            // required to be emitted
            // when QDialog emits "hide" event
            this.$emit("hide");
        },

        onOKClick() {
            // validate input
            if (!this.$refs["billID"].validate()) {
                return;
            }

            if (!this.$refs["totalPaid"].validate()) {
                return;
            }
            // on OK, it is REQUIRED to
            // emit "ok" event (with optional payload)
            // before hiding the QDialog
            this.$emit("ok", {
                orderId: this.orderID,
                billID: this.billID,
                totalPaid: this.totalPaid,
                remark: this.remark,
                subTotal: this.subTotal,
                grandTotal: this.grandTotal,
                discountAmount: this.discountAmount,
                shippingAmount: this.shippingAmount,
            });
            // or with payload: this.$emit('ok', { ... })

            // then hiding dialog
            this.hide();
        },

        onCancelClick() {
            // we just need to hide the dialog
            this.hide();
        },

        onCopy() {
            copyToClipboard(this.url);
        },
    },
};
</script>
